module.exports = __webpack_public_path__ + "img/b3.e2094d3f.png";